import React, { useEffect, useState, useRef } from 'react';
import useApp from 'hooks/useApp'
import { Link, useNavigate } from 'react-router-dom'
import { Button, LayerBottom, NoData } from 'components'
import styles from './index.module.css'
import Lib from 'library'

const GrantList = () => {

	const App = useApp()
	const navigate = useNavigate();
	const [filterLayer, setFilterLayer] = useState(false);
	const [rcmndAidData, setRcmndAidData ] = useState(null);
	const [pagination, setPagination] = useState(null);
	const mounted = useRef(null);

	const routerLifeMain = () => {
		navigate('/life');
	};

	const openFilter = () => {
		setFilterLayer(true)
	}

	const closeFilter = () => {
		setFilterLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={() => routerLifeMain()} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])


	// 신청가능 정부지원금 추천 목록 조회 API
	const getRcmndAid = () => {
		Lib.get('/api/rcmnd/gvrnm/aid/?pageNo=1&rowsPerPage=10', data => {
			console.log( data );
			setRcmndAidData(data);
		});
	}

	useEffect(()=>{
		mounted.current = true;
		mounted.current && getRcmndAid();
		return () => mounted.current = false;
	}, [])
	

	return (
		<div className="page">
			<div className="shadow">
				<div className={`${styles["grant-visual"]} padding pt_50 pb_40`}>
					<div className={styles.title}>
						내 조건에 딱 맞는<p>정부지원금은?</p>
					</div>
					<div className="mt_20">조건 수정 시 최적화된<br />정부지원금이 조회돼요!</div>
					<div className={`${styles.update} mt_20`} style={{ fontSize: "1.4rem" }}>
						2022.01.01 기준<i className="icon icon_update ml_10" />
					</div>
					<div className={styles["life-object"]} style={{ top: "1rem" }}>
						<div style={{ width: "14.4rem", height: "22.4rem" }} />
					</div>
				</div>
				<div className="padding">
					<ul className={styles["grant-menu"]}>
						<li>
							<p>기본정보</p>
							<div><strong>3</strong> 건</div>
						</li>
						<li>
							<p>소득정보</p>
							<div><strong>3</strong> 건</div>
						</li>
						<li>
							<p>특성정보</p>
							<div><strong>0</strong> 건</div>
						</li>
					</ul>
					<Link to="/life/grantSelect" className="btn-link btn--gradient mt_30">조건 변경하기<i className="icon icon_btn_arrow_white ml_5" style={{ marginTop: "-0.3rem" }} /></Link>

					{/* 데이터 수집 실패한 경우 노출 */}
					<div className={`${styles["error-box"]} mt_30`} style={{ fontSize: "1.2rem" }}>[데이터 수집 실패] 조건변경 버튼을 클릭해 정확한 정보를<br />알려주시면 좀 더 최적화된 정부지원금이 조회돼요!</div>
				</div>
			</div>
			<div className="padding pb_20">
				<h3>김모니님이 받을 수 있는 정부지원금</h3>
				<div className="flex-justify_between align_center mt_20">
					<div className={styles["total-count"]}><strong>1,752</strong>건</div>
					<div className="filter-group">
						<div onClick={openFilter}>
							<span>전체∙100%이하</span>
							<i className="icon icon_filter ml_5" />
						</div>
					</div>
				</div>
			</div>
			<ul className={`${styles["grant-list"]} list-bg`}>
				{console.log( rcmndAidData )}
				{
					rcmndAidData ? (
						rcmndAidData.length !== 0 
							? (
								rcmndAidData.map((aid, index) => 
									<li key={index}>
										<div className={styles.category}>지자체 지원금 <i className="tag tag-round tag-red ml_5">100% 적합</i></div>
										<p className={`${styles.title} ellipsis`}>{aid.gvrnmAidNm}</p>
										<div className={styles.info}>최대 5,000만원 (연 4회)</div>
										<div className={styles["tag-group"]}>
											<span>#주거급여수금</span>
										</div>
									</li>
								)
							) : (
								<NoData />
							)
					) : (
						<li>
							<div className={`${styles.category} skeleton`} style={{ width: '16rem', height: '2rem' }}></div>
							<p className={`${styles.title} ellipsis skeleton`} style={{ width: '23rem', height: '2rem' }}></p>
							<div className={`${styles.info} skeleton`} style={{ width: '6rem', height: '2rem' }}></div>
							<div className={styles["tag-group"]}>
								<span className="skeleton" style={{ width: '8rem', height: '2rem' }}></span>
							</div>
						</li>
					)
				}
				{/* <li>
					<div className={styles.category}>지자체 지원금 <i className="tag tag-round tag-red ml_5">100% 적합</i></div>
					<p className={`${styles.title} ellipsis`}>대형 건축물 부설 주차장(노외주차장포함)방법설치 대형 건축물 부설 주차장(노외주차장포함)방법설치</p>
					<div className={styles.info}>최대 5,000만원 (연 4회)</div>
					<div className={styles["tag-group"]}>
						<span>#주거급여수금</span>
					</div>
				</li>
				<li>
					<div className={styles.category}>복지로 <i className="tag tag-round tag-blue ml_5">70% 적합</i></div>
					<p className={`${styles.title} ellipsis`}>어린이집 안전 관리 비용 지원</p>
					<div className={styles["tag-group"]}>
						<span>#차상위</span>
						<span>#저소득층</span>
					</div>
				</li>
				<li>
					<div className={styles.category}>보조금24 <i className="tag tag-round tag-blue ml_5">90% 적합</i></div>
					<p className={`${styles.title} ellipsis`}>건축물 등기 촉탁 무료 서비스</p>
					<div className={styles["tag-group"]}>
						<span>#지역가입자</span>
						<span>#무주택</span>
						<span>#장애인외3건</span>
					</div>
				</li> */}
			</ul>
			<div className="padding">
				<Button className="btn btn--big btn-more">+ 더보기</Button>
			</div>
			<FilterLayer show={filterLayer} closeLayer={closeFilter} />
		</div>
	)
}

const FilterLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="필터" show={show} closeLayer={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>확인</Button>
		}>
			<ul className="filter-option">
				<li>
					<p>지원금 유형</p>
					<ul className="opt-menu mt_10">
						<li className="active">전체</li>
						<li>지자체지원금</li>
						<li>보조금24</li>
						<li>복지로</li>
					</ul>
				</li>
				<li>
					<p>적합도 설정</p>
					<div className={`${styles["percentage-wrap"]} mt_20`}>
						<ul className={styles["circle-percentage"]}>
							<li className={styles.on}>
								<div className={styles.circle} />
							</li>
							<li className={styles.on}>
								<div className={styles.circle} />
							</li>
							<li>
								<div className={styles.circle} />
							</li>
							<li>
								<div className={styles.circle} />
							</li>
						</ul>
						<ul className={`${styles["txt-guide"]} mt_5`}>
							<li className={styles.on}>70%</li>
							<li className={styles.on}>80%</li>
							<li>90%</li>
							<li>100%</li>
						</ul>
						{/* 33.33%, 66.66%, 99.99% */}
						<span className={styles.line} style={{ width: "33.33%" }} />
					</div>
				</li>
			</ul>
		</LayerBottom>
	)
}

export default GrantList